import * as React from 'react';
import { DashboardLayout, } from '@Layouts';

const DashboardPage: React.FC = () => <DashboardLayout />;

export default DashboardPage;
